import styled from 'styled-components'

import CircleInfo from '~/features/circle-info/CircleInfo'
import CircleInfoTopSection from '~/features/circle-info/CircleInfoTopSection'
import theme from '~/shared/styles/theme'

function CircleInfoPage() {
  return (
    <Wrapper>
      <CircleInfoTopSection />
      <CircleInfo />
    </Wrapper>
  )
}

export default CircleInfoPage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: ${theme.size.headerHeight}px;
  padding: 36px 24px;

  @media ${theme.device.large} {
    gap: 48px;
    padding: 0 60px;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    margin-top: ${theme.size.mobileHeaderHeight}px;
    padding: 0 20px;
  }
`
